export const STATISTICS_FETCHING_ERROR_PREFIX = 'Failed to fetch statistics';
